import { render } from "./MainParagraphCard.vue?vue&type=template&id=6a1bd703&scoped=true"
import script from "./MainParagraphCard.vue?vue&type=script&lang=js"
export * from "./MainParagraphCard.vue?vue&type=script&lang=js"

import "./MainParagraphCard.vue?vue&type=style&index=0&id=6a1bd703&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1bd703"]])

export default __exports__